import { motion } from "framer-motion";
import { X } from "lucide-react";
import { imgSrc } from "./repApi";

/* পাশাপাশি তুলনা — দাম, রং, শিল্প, মাপ, ট্রাই-অন */
export default function Compare({ results, products, onClose, onSave, onOrder, saved }) {
  const pair = results.slice(-2);
  const items = pair
    .map((pid) => products.find((p) => p.id === pid))
    .filter(Boolean);
  if (items.length < 2) return null;
  const rows = [
    ["দাম", (p) => p.price],
    ["রং", (p) => p.colour || "—"],
    ["শিল্প", (p) => p.craft || "—"],
    ["মাপ", (p) => (p.sizes || []).join(", ") || "—"],
  ];
  return (
    <motion.div
      className="fixed inset-0 z-[92] flex items-center justify-center bg-dusk/90 p-4 backdrop-blur-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      data-testid="tryon-compare"
    >
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        className="relative max-h-[92vh] w-full max-w-4xl overflow-y-auto rounded-2xl border border-gold/25 bg-plaster p-6 sm:p-8"
      >
        <button
          data-testid="compare-close"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 rounded-full bg-dusk/70 p-2 text-sand/70 transition-colors hover:text-sand"
          aria-label="বন্ধ করুন"
        >
          <X size={16} />
        </button>
        <h3 className="font-display text-2xl text-sand sm:text-3xl">পাশাপাশি দেখুন</h3>
        <p className="mt-1 text-xs text-sand/50">চিত্রা বলছেন — দুটোর মধ্যে যেটা চোখে লাগে, সেটাই নিন।</p>

        <div className="mt-6 grid gap-5 sm:grid-cols-2">
          {items.map((p, i) => {
            const isSaved = saved.includes(p.id);
            return (
              <div key={p.id} className="overflow-hidden rounded-xl border border-gold/20 bg-earthen/60">
                <img src={imgSrc(p.tryonUrl)} alt={p.title} className="h-64 w-full object-cover sm:h-80" data-testid={`compare-img-${p.id}`} />
                <div className="p-4">
                  <h4 className="font-display text-lg text-sand">{p.title}</h4>
                  <table className="mt-3 w-full text-left text-xs">
                    <tbody>
                      {rows.map(([label, get]) => (
                        <tr key={label} className="border-b border-gold/10 last:border-0">
                          <td className="py-1.5 pr-3 whitespace-nowrap text-sand/45">{label}</td>
                          <td className="py-1.5 text-sand/85">{get(p)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="mt-4 flex flex-wrap gap-2">
                    <button
                      data-testid={`compare-save-${p.id}`}
                      onClick={() => onSave(p.id)}
                      className={`rounded-full px-4 py-2 text-xs transition-all duration-300 ${
                        isSaved ? "bg-vermilion text-alpana" : "border border-gold/40 text-gold hover:bg-gold hover:text-dusk"
                      }`}
                    >
                      {isSaved ? "পছন্দ জমা আছে" : "এটা পছন্দ"}
                    </button>
                    <button
                      data-testid={`compare-order-${p.id}`}
                      onClick={() => onOrder(p)}
                      className="rounded-full bg-alpana px-4 py-2 text-xs font-medium text-dusk transition-transform duration-300 hover:scale-105"
                    >
                      অর্ডার করুন
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </motion.div>
    </motion.div>
  );
}
